import { GraphQLClient } from 'graphql-request'
import { RequestConfig } from 'graphql-request/build/esm/types'
import { getBearerToken } from '../../../../auth'

export interface GQLRequestParam {
  endpoint?: string
  options?: RequestConfig
}

/**
 * @param param - GQLRequestParam
 */
export const graphqlGLClient = (param?: GQLRequestParam): GraphQLClient => {
  const bearerToken = getBearerToken()
  // if (!bearerToken) {
  //   throw new Error('Bearer token is not set')
  // }
  if (!param?.endpoint && !process.env.REACT_APP_GQL_URI) {
    throw new Error('Endpoint is not set')
  }
  const endpoint = (param?.endpoint || process.env.REACT_APP_GQL_URI) as string
  const gqlClient = new GraphQLClient(endpoint, param?.options || {})
  gqlClient.setHeader('authorization', `Bearer ${bearerToken}`)
  return gqlClient
}
